import {fromJS} from 'immutable'
import {post, get, put, uploadImage} from '../../util/http'
import {FBLogin} from '../../util/facebook'
import {getUserInfo} from './profile'
import {showToast} from './toast'
import {hideModal} from './modal'
// import * as mixpanel from '../../util/mixpanel';

/**
 * Actions
 */
const ATTEMPT_API = 'expii/session/ATTEMPT_API'
const PROCESS_LOGIN = 'expii/session/PROCESS_LOGIN'
export const PROCESS_LOGOUT = 'expii/session/PROCESS_LOGOUT'

/**
 * Action Creators
 */
export function attemptAPI() {
  return { type: ATTEMPT_API }
}

export function processLogin(user_data) {
  return { type: PROCESS_LOGIN, payload: user_data }
}

export function processLogout(user_data) {
  return { type: PROCESS_LOGOUT, payload: user_data }
}

// export type Actions = ExtractReturn<typeof attemptAPI> |
//                       ExtractReturn<typeof processLogin>;

/**
 * Reducer
 */
const defaultLoginState = fromJS({
  isFetching: false,
  user:{
    id:0
  },
})

export default function reducer(state = defaultLoginState, action) {
  switch (action.type) {
  case ATTEMPT_API:
    return state.set('isFetching', true)
  case PROCESS_LOGOUT:
    return defaultLoginState
  case PROCESS_LOGIN:
    const {success, ...rest} = action.payload
    return state.merge(fromJS({
      ...rest,
      isFetching: false
    }))
  default:
    return state
  }
}


/**
 * Side Effects
 */

function handleLogin(dispatch, json) {
  let {success, output} = json
  json = {
    success:success,
    user:output
  }
  if (success) {
    // dispatch(hideModal())
    window.location.reload() //@TODO: figure out ways to reload state so this is unnecessary?
  }
  // dispatch(processLogin(json))
  // dispatch(getJourney())
}

export function postFacebookLogin() {
  return (dispatch, getState) => {
    return FBLogin()
      .then(response => {
        if (response.status !== 'connected') {
          console.error('Connecting to Facebook failed')
          return
        }

        return post(`/v2/oauth/facebook/set_user_from_access_token/${ response.authResponse.accessToken }`, {
          data: response.authResponse,
        }).then((json)=>{
          // mixpanel.register({
          //   'registered': true,
          //   'user_id': json.output.user.id
          // })
          // if(json.output.existing_user) {
          //   mixpanel.identify(json.output.user.id);
          //   mixpanel.track('XP_login', { method: 'facebook' });
          // } else {
          //   mixpanel.identify();
          //   mixpanel.track('XP_register', { method: 'facebook' });
          //   mixpanel.alias(json.output.user)
          // }
          let {success, output} = json
          json = {
            success:success,
            output: output.user
          }
          handleLogin(dispatch, json)
        })
      }).catch(response=> {
        console.log('caught error connecting to facebook')
      })
  }
}

export function postLogin(user_info) {
  return (dispatch, getState) => {
    dispatch(attemptAPI())
    return post(`/api/session/login`,user_info)
      .then((json)=>{
        // mixpanel.identify(json.output.id)
        // mixpanel.register({
        //   'registered': true,
        //   'user_id': json.output.id
        // })
        // mixpanel.track('XP_login', { method: 'email' });
        handleLogin(dispatch, json)
      }).catch(json => {
        dispatch(showToast({
          'text': json.error_message,
          'timeout': 5000
        }))
      })
  }
}


export function postRegister(user_info) {
  return (dispatch, getState) => {
    dispatch(attemptAPI())
    return post('/api/session/register',user_info)
      .then((json)=>{
        // mixpanel.identify();
        // mixpanel.register({
        //   'registered': true,
        //   'user_id': json.output.id,
        // })
        // mixpanel.track('XP_register', { method: 'email' });
        // mixpanel.alias(json.output);
        handleLogin(dispatch, json)
      }).catch(json => {
        // if the serverside validation fails, this shows the error message to inform the user (ie email already in use)
        dispatch(showToast({
          'text': json.error_message,
          'timeout': 5000
        }))
      })
  }
}

export function postForgotPassword(user_info) {
  return (dispatch, getState) => {
    return post('/api/session/send_reset_password_email', user_info)
      .then(json => {
        // Display success message and close modal
        dispatch(showToast({
          'text': json.output,
          'timeout': 5000
        }))
        dispatch(hideModal())
      }).catch(json => {
        // If user email does not exist on server, this shows error message
        dispatch(showToast({
          'text': json.error_message,
          'timeout': 5000
        }))
      })
  }
}

export function getSession() {
  return (dispatch, getState) => {
    dispatch(attemptAPI())
    return get(`/api/v2/session`)
      .then(json => {
        let {success, output} = json
        json = {
          success:success,
          ...output
        }
        // mixpanel.register({
        //   'registered': output.user.id ? true : false,
        //   'user_id': output.user.id,
        //   'abTestBuckets': output.abTestBuckets
        // })
        // mixpanel.identify(output.user.id)
        dispatch(processLogin(json))
        //output.user.id && dispatch(getJourney())
      }
      )
  }
}

export function getLogout() {
  return (dispatch, getState) => {
    dispatch(attemptAPI())
    return get(`/api/v2/logout`)
      .then(json => {
        let {success, output} = json
        json = {
          success:success,
          user:output
        }
        // dispatch(processLogout(json));
        // dispatch(resetJourney());
        //mixpanel.reset();
        window.location.reload()
      }
      )
  }
}

export function putSaveAccountChanges(displayName, pictureFile, imagePreview, email) {
  return (dispatch, getState) => {
    const handleResponse = (json) => {
      dispatch(processLogin({'user':json.output}))
      const loadedProfileId = parseInt(getState().getIn(['profile','userInfo','id']))
      if (userId === loadedProfileId) {
        dispatch(getUserInfo(userId))
      }
    }

    const userId = parseInt(getState().getIn(['session','user','id']))
    const currPicture = getState().getIn(['session','user','profilePicture'])
    if (pictureFile) {

      return uploadImage(pictureFile)
        .then(json => {
          return put(`/api/v2/user/${ userId }`, { display_name: displayName, profile_picture: pictureFile.name, email: email})
        })
        .then(handleResponse)
    } else if (currPicture !== imagePreview && !pictureFile) {
      return put(`/api/v2/user/${ userId }`, { display_name: displayName, profile_picture: null, email: email })
        .then(handleResponse)
    } else {
      return put(`/api/v2/user/${ userId }`, { display_name: displayName, email: email })
        .then(handleResponse)
    }
  }
}

export function postSaveChangePassword(currentPassword, newPassword) {
  return (dispatch, getState) => {
    return post('/api/update_password', {'current_password': currentPassword, 'new_password': newPassword})
      .then(json => {
        return json.output
      })
  }
}

export function postOauth(search) {
  return (dispatch, getState) => {
    return post(`/v2/oauth-flask/authorize${search}`)
  }
}




/**
 * Selectors
 */
const _selectUserInfo = (domain) => {
  const user = domain.get('user')
  return {
    user: user,
    role: user.get('role'),
    isLoggedIn: !user.isEmpty() && parseInt(user.get('id')),
    isFetching: domain.get('isFetching')
  }
}
export const selectUserInfo = (state) => {
  return _selectUserInfo(state.get('session'))
}



// WEBPACK FOOTER //
// ./src/redux/modules/session.js